import { FunctionComponent } from 'react';

export const Floor: FunctionComponent = () => {
  return (
    <group>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 50]} receiveShadow>
        <planeGeometry attach="geometry" args={[100, 100]} />
        <shadowMaterial attach="material" transparent opacity={0.5} />
      </mesh>
      <mesh
        rotation={[-Math.PI / 2, 0, 0]}
        position={[0, -0.002, 50]}
        receiveShadow
      >
        <planeGeometry attach="geometry" args={[100, 100]} />
        <meshStandardMaterial attach="material" color={'white'} />
      </mesh>
    </group>
  );
};
